import React, { useState } from 'react';
import { Polygon } from '@react-google-maps/api';
import { useSelector } from 'react-redux';
import { SHAPE_TYPE } from 'helpers/constants';
import { getZoneOptions } from 'helpers/utils';

const ViewNewDrawnPolygon = (props) => {
  const { onShapesComplete } = props;

  const zoneState = useSelector((state) => state.zone.geoRadarZone) ?? null;
  const [drawnPolygonRef, setDrawnPolygonRef] = useState(null);

  const onDrawnPolygonLoad = (polygon) => setDrawnPolygonRef(polygon);

  const onPolygonMouseUp = () =>
    onShapesComplete(drawnPolygonRef, SHAPE_TYPE.POLYGON);

  const polygonOptions = getZoneOptions({
    fillColor: zoneState?.zoneColor.color,
    fillOpacity: zoneState?.zoneOpacity,
  });

  return (
    <Polygon
      paths={[zoneState?.drawnPolygonPaths]}
      onLoad={onDrawnPolygonLoad}
      editable
      draggable
      onMouseUp={onPolygonMouseUp}
      options={polygonOptions}
    />
  );
};

export default ViewNewDrawnPolygon;
